/**
 * OrderMethodsProvider
 */

import React, { useEffect, useState, useContext } from 'react'
import { CacheChecksumContext, createPersistedState } from '../../cache'
import { cancelRequest, getAllDataInParallel } from '../../helpers'
import OrderMethodsContext from './order-methods-context'
import { fetchOrderMethods } from './order-methods-api'

// create use state hook with persisted storage
// TODO: support using different storage provider
const useOrderMethodsState = createPersistedState('orderMethods')
const useOrderMethodsChecksumState = createPersistedState('orderMethodsChecksum')

export default function OrderMethodsProvider({ children }) {

  const [orderMethods, setOrderMethods] = useOrderMethodsState([])
  const [orderMethodsChecksum, setOrderMethodsChecksum] = useOrderMethodsChecksumState('')
  const [orderMethodsReady, setOrderMethodsReady] = useState(false)

  // handle cache checksum value
  const { getChecksum } = useContext(CacheChecksumContext)
  const cacheChecksumValue = getChecksum('orderMethods')

  function fetchOrderMethodsAll(params) {
    return getAllDataInParallel({
      fn: (args) => fetchOrderMethods({
        ...params,
        ...args,
      }),
      key: 'orderMethods',
    })
  }

  function refresh() {
    fetchOrderMethodsAll()
      .then(({ orderMethods: data, cacheChecksum }) => {
        setOrderMethods(data)
        setOrderMethodsChecksum(_.get(cacheChecksum, 'orderMethodsValue'))
        setOrderMethodsReady(true)
      })
  }

  // useEffect(() => {
  //   return () => {
  //     cancelRequest.cancel()
  //   }
  // }, [])

  useEffect(() => {
    if (cacheChecksumValue !== orderMethodsChecksum || _.isEmpty(cacheChecksumValue)) {
      refresh()
    } else {
      setOrderMethodsReady(true)
    }
    return function cleanUp() {
      cancelRequest.cancel('fetchOrderMethods')
    }
  }, [orderMethodsChecksum, cacheChecksumValue])

  const state = {
    fetchOrderMethods,
    fetchOrderMethodsAll,
    orderMethodsReady,
    orderMethods,
  }

  return (
    <OrderMethodsContext.Provider value={state}>
      {children}
    </OrderMethodsContext.Provider>
  )
};
